module.exports = __webpack_public_path__ + "img/mon-3.62341b1.svg";